import { v4 as uuidv4 } from 'uuid';

import {
  getStaticData,
  getNielsenData,
} from 'support/analytics/analyticsHelper';

import { VideoCtvRedux } from 'store-types';
import { AppDispatch } from 'app-types';

export const TRACK_PAGE = 'TRACK_PAGE' as const;
export const TRACK_EVENT = 'TRACK_EVENT' as const;

export const getPPlusUserFromState = (state: VideoCtvRedux) =>
  state?.auth?.paramountPlus?.user?.data;
export const getMvpdFromState = (state: VideoCtvRedux) => state?.auth?.adobe?.authN?.mvpd;

const getAuthFromState = (state: VideoCtvRedux): [ReturnType<typeof getPPlusUserFromState>, ReturnType<typeof getMvpdFromState>] => {
  const ppUser = getPPlusUserFromState(state);
  const mvpd = getMvpdFromState(state);
  return [ppUser, mvpd];
};

const getPageNameFromState = (state: VideoCtvRedux) =>
  state?.analytics?.tracking?.latestTracked?.pageName;
const getSiteHierFromState = (state: VideoCtvRedux) =>
  state?.analytics?.tracking?.latestTracked?.siteHier;

export const trackPage = (data: Record<string, unknown>) => async (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const state = getState();
  const [ppUser, mvpd] = getAuthFromState(state);

  const payload = {
    pageViewGuid: uuidv4(),
    ...data,
    ...(await getStaticData(ppUser, mvpd)),
    ...(await getNielsenData()),
  };

  dispatch({
    type: TRACK_PAGE,
    payload,
  });
};

export const trackEvent = (eventName: string, data: Record<string, unknown>) => async (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const state = getState();
  const [ppUser, mvpd] = getAuthFromState(state);

  const payload = {
    ...data,
    ...(await getStaticData(ppUser, mvpd)),
    pageName: getPageNameFromState(state),
    siteHier: getSiteHierFromState(state),
    eventName,
  };

  dispatch({
    type: TRACK_EVENT,
    payload,
  });
};
